module.exports = __webpack_public_path__ + "static/media/29FUNOV8.e8470bbd.jpg";